/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_It_Works__Callout_SubtitleInputs */

const en_how_it_works__callout_subtitle = /** @type {(inputs: How_It_Works__Callout_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BidBattles is a capped-player auction platform where premium products like cars, electronics, and experiences are up for grabs. Unlike traditional auctions, each battle has a limited number of seats and uses a unique timer system where strategic bidding can extend the countdown. The last bidder when the timer hits zero wins!`)
};

/**
* | output |
* | --- |
* | "BidBattles is a capped-player auction platform where premium products like cars, electronics, and experiences are up for grabs. Unlike traditional auctions, ..." |
*
* @param {How_It_Works__Callout_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const how_it_works__callout_subtitle = /** @type {((inputs?: How_It_Works__Callout_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_It_Works__Callout_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_how_it_works__callout_subtitle(inputs)
});